import React from "react";
import program from "../../../assets/images/program.webp";

function Program() {
  return (
    <section className="layout-section">
      <div className="layout-container">
        <h1 id="heading-large" className="text-center">
          Ever Sky Scholarship Program
        </h1>
        <p className="my-4 text-gray-600 leading-relaxed max-w-4xl mx-auto">
          Ever Sky Overseas is proud to sponsor the Ever Sky Scholarship program.
          This initiative offers deserving study-abroad aspirants the opportunity to
          cover a substantial part of their tuition fees at reputed universities
          and colleges in the USA, Canada, and the UK, along with accommodation
          support for the duration of their studies.
        </p>
        <div className="h-auto p-6 sm:p-8 bg-slate-100 rounded-md flex flex-col md:flex-row gap-6" id="dark">
          <div className="md:w-3/5">
            <h1 id="heading-md">To be eligible, the candidate should</h1>
            <ul className="list-disc ml-6 mt-3 space-y-1">
              <li>Be an Indian citizen</li>
              <li>Have attained a High School Diploma or have a GED Certificate</li>
              <li>Have family income (from all sources) of less than INR 6 lakh per year</li>
              <li>Have a minimum score of 6.0 bands overall in IELTS</li>
              <li>Have applied to a full-time program of at least one year</li>
              <li>Complete the college admission procedure through Ever Sky Overseas or an authorized partner</li>
              <li>Have admission from a valid higher education institution in the USA, Canada, the UK, Australia, New Zealand, Germany, France, or Singapore</li>
            </ul>
            <a href="/pricing">
              <button className="btn-primary mt-4">Apply Now — ₹4,999</button>
            </a>
          </div>
          <div className="md:w-2/5 flex justify-center items-center">
            <img src={program} alt="Scholarship program" className="w-full h-auto rounded-lg" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Program;
